import { render } from "./configManage.vue?vue&type=template&id=b36ffd48&scoped=true"
import script from "./configManage.vue?vue&type=script&lang=js"
export * from "./configManage.vue?vue&type=script&lang=js"

import "./configManage.vue?vue&type=style&index=0&id=b36ffd48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36ffd48"]])

export default __exports__